import type { ReactElement } from 'react';
import type { BeneficialOwnerResponse } from '@gcv/shared';
import { BeneficialOwnerUpdateAction } from '@gcv/shared';
import { Box } from '@mui/material';

import { Text } from 'ui';
import palette from 'ui/theme/palette';
import { DateTimeHelpers } from 'util/dateTime.util';

export const getBeneficialOwnerQuestionnaireRowBlurb = (owner: BeneficialOwnerResponse): ReactElement => {
  const date = DateTimeHelpers.formatISOToFriendlyDateString(owner.last_update.date, undefined);
  const status = owner.archived
    ? {
        backgroundColor: palette.background.secondary,
        borderColor: palette.text.disabled,
        color: palette.text.secondary,
        content: 'Archived'
      }
    : owner.last_update.update_action === BeneficialOwnerUpdateAction.Add
    ? {
        backgroundColor: palette.background.secondary,
        borderColor: palette.text.disabled,
        color: palette.text.secondary,
        content: 'New'
      }
    : owner.last_update.update_action === BeneficialOwnerUpdateAction.Certify
    ? {
        backgroundColor: palette.background.secondary,
        borderColor: palette.text.disabled,
        color: palette.text.secondary,
        content: `Last Certified - ${date}`
      }
    : {
        backgroundColor: palette.warning.background,
        borderColor: palette.warning.border,
        color: palette.warning.text,
        content: `Last Updated by ${owner.last_update.by_display_name ?? '--'} - ${date}`
      };

  return (
    <Box
      sx={{
        backgroundColor: status.backgroundColor,
        border: 1,
        borderColor: status.borderColor,
        borderRadius: '4px',
        borderStyle: 'solid',
        padding: '2px 8px'
      }}
    >
      <Text
        content={status.content}
        type="body4"
        sx={{ color: status.color, fontWeight: 700, whiteSpace: 'nowrap' }}
      />
    </Box>
  );
};
